<template>
  <b-card
    class="text-center"
    :class="(flagcontinue) ? 'cursor-pointer importanteItem' : ''"
    :border-variant="(flagcontinue) ? '' : 'warning'"
    :img-src="require('@/assets/images/illustration/marketing.svg')"
    img-alt="Moodle-Salon"
    img-top
    :disabled="(flagcontinue) ? false : true"
    @click="redirectModle()"
  >
    <h4>Acceso a salón de clase</h4>
    <b-card-text class="mt-1">
      Hola <b>{{ getSession.cuenta }}</b>,  <small :class="(flagcontinue) ? 'text-primary': 'text-danger'">{{ (flagcontinue) ? 'con esta opción podra ingresar a su salón.' : 'lo sentimos no tiene el salón habilitado.' }}</small>
    </b-card-text>
  </b-card>
</template>
<script>
import { BCard, BCardText } from 'bootstrap-vue'
import store from '@/store'
import { isEmptyObject } from '@core/utils/utils'
import { ref, onMounted } from '@vue/composition-api'

export default {
  name: 'DashAlumno',
  components: {
    BCard,
    BCardText,
  },
  data() {
    return {
      loader: {
        pagina: false,
      },
      kbasesores: [],
    }
  },
  computed: {
    getSession() {
      if (!isEmptyObject(this.$store.getters['cuenta/getSession'])) return this.$store.getters['cuenta/getSession']
      return {}
    },
    getAccount() {
      return this.$store.getters['cuenta/getAccount']
    },
  },
  setup() {
    const flagcontinue = ref(false)
    const verificando = () => {
      if (store.state.cuenta.session.tknmdl != null) {
        flagcontinue.value = true
      }
    }
    const redirectModle = () => {
      // usar siempre https, para envio de credenciales
      if (flagcontinue.value) {
        const routeData = `${process.env.VUE_APP_MOODLE_API}${process.env.VUE_APP_SERVICE_APIMDL}?token=${store.state.cuenta.session.tknmdl}&task=redirect`
        // window.open(routeData, 'Salon de Clases')
        window.location.replace(routeData)
      }
    }
    onMounted(
      () => {
        verificando()
      },
    )
    return {
      verificando,
      flagcontinue,
      redirectModle,
    }
  },
}
</script>
<style scoped>
.importanteItem {
  border: 1px solid #7367f0;
}
</style>
